import { render, staticRenderFns } from "./OpenCartPackages.vue?vue&type=template&id=8d4f5530&"
import script from "./OpenCartPackages.vue?vue&type=script&lang=js&"
export * from "./OpenCartPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OpenCartPackages.vue"
export default component.exports